module.exports = __webpack_public_path__ + "static/media/spmobilesense-inline.80e8e734.jpg";